import React, { useState, memo, useLayoutEffect, useRef } from 'react';
import { useIntl } from 'umi';
import { Button, SegmentMultiple, Segment } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';
const DEFAULT_HEIGHT = 44;

export default memo((props:any) => {
  const {
    options = [],
    value = [],
    onChange,
    label,
    labelWidth = '60px',
    style,
    className = '',
    defaultHeight = DEFAULT_HEIGHT,
    isMultiple=true,
  } = props;
  const [expand, setExpand] = useState(false);
  const [showExpand, setShowExpand] = useState(false);
  const { formatMessage, locale } = useIntl();
  const segmentRef = useRef<HTMLDivElement | null>(null);
  const lastScrollHeightRef = useRef(defaultHeight); // 用于记录上一次的滚动高度, 判断是否显示展开收起按钮

  // 监控页面宽度变化时, 设置展开收起按钮的显示和隐藏
  useLayoutEffect(() => {
    lastScrollHeightRef.current = segmentRef.current?.scrollHeight;
    // 监控宽高变化
    const resizeObserver = new ResizeObserver(() => {
      // 前后滚动高度一致, 无需处理
      if (segmentRef.current?.scrollHeight === lastScrollHeightRef.current) return;
      // 如果现在的滚动高度大于了一行的滚动高度, 说明需要显示展开收起按钮
      // @ts-ignore
      if (segmentRef.current?.scrollHeight > defaultHeight) {
        setShowExpand(true);
      } else {
        setShowExpand(false);
      }
      lastScrollHeightRef.current = segmentRef.current?.scrollHeight;
    });
    resizeObserver.observe(segmentRef.current!);
    return () => {
      resizeObserver.unobserve(segmentRef.current!);
    };
  }, []);
  
  // 监控 选项options变化时, 展开收起按钮的变化
  useLayoutEffect(() => {
    // @ts-ignore
    if (segmentRef.current?.scrollHeight <= DEFAULT_HEIGHT) setShowExpand(false);
  }, [options]);
  const Component = isMultiple ? SegmentMultiple : Segment;
  return (
    <div
      className={`dbl-segment-multiple ${className}`}
      style={{ height: showExpand && !expand ? `${defaultHeight}px` : 'auto', ...style }}
      ref={segmentRef}
    >
      {label ? (
        <div style={{ width: labelWidth }} className={'dbl-segment-multiple-label'}>
          {label}
        </div>
      ) : (
        ''
      )}
      <Component
        className={'dbl-segment-multiple-wrap'}
        options={options?.map((opt: any) => ({...opt, value: opt?.value, text: (locale === 'zh-CN' ? opt?.text : opt?.textEn) || opt?.text }))}
        value={value}
        onChange={onChange}
      />
      {showExpand ? (
        <div className={'dbl-segment-multiple-expand'}>
          <Button
            type={'link'}
            className={'expand-btn'}
            onClick={() => {
              setExpand(!expand);
            }}
          >
            {formatMessage({ id: expand ? 'dbl_common_collapse' : 'dbl_common_expand' })}&nbsp;
            <SvgIcon type={expand ? 'arrow-up' : 'arrow-down'} />
          </Button>
        </div>
      ) : (
        ''
      )}
    </div>
  );
});
